import EditCaseManager from "./EditCaseManager";

export default EditCaseManager;
